import { Component, OnInit } from '@angular/core';

// Service
import { ApiService } from '../../shared/service/api.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styles: [
  ]
})
export class AboutComponent implements OnInit {

  dataBanner;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.apiService.getDataApi('getSubHeaderByLink/about-us').subscribe(response => {
        this.dataBanner = response.data;
    });
  }

}
